// extracted by mini-css-extract-plugin
export default {"title":"Vaa-z","warning":"Waa-z","sizeOptionsLegendText":"Xaa-z"};